import React from 'react';
import { motion } from 'framer-motion';
import { FileText, Zap, Layers, ShieldCheck, CreditCard, Star, Flame } from 'lucide-react';
export function Hero() {
  const badges = [{
    icon: <FileText size={16} data-id="element-83" />,
    text: 'PDF imprimible'
  }, {
    icon: <Zap size={16} data-id="element-84" />,
    text: 'Acceso inmediato'
  }, {
    icon: <Layers size={16} data-id="element-85" />,
    text: 'Organizado por edades'
  }];
  return <section className="relative pt-6 pb-8 px-3 md:pt-10 md:pb-12 max-w-5xl mx-auto text-center overflow-hidden" data-id="element-86">
      <div className="absolute inset-0 pointer-events-none" style={{
      background: 'radial-gradient(ellipse at center, rgba(184,153,104,0.18) 0%, rgba(184,153,104,0.08) 40%, transparent 70%)'
    }} data-id="element-87" />

      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.8
    }} data-id="element-88">
        <span className="inline-block py-1 px-3 rounded-full bg-accent/10 text-accent font-semibold text-xs mb-4 tracking-wide uppercase border border-accent/30 shadow-[0_0_25px_rgba(184,153,104,0.35)]" data-id="element-89">
          Recursos profesionales
        </span>

        <h1 className="md:text-5xl lg:text-6xl mb-4 text-ink text-[24px] font-[900] font-[Poppins,_sans-serif]" data-id="element-90">
          Recursos de inclusión <span className="text-sky" data-id="element-91">listos</span> para
          usar durante todo el año
        </h1>

        <p className="md:text-2xl text-accent/90 mb-6 max-w-3xl mx-auto font-[600] font-['Open_Sans',_sans-serif] text-[14px]" data-id="element-92">
          Materiales prácticos para docentes y profesionales que acompañan a
          niños con diferentes necesidades de aprendizaje.
        </p>

        <div className="mb-8 mt-2 flex justify-center" data-id="element-93">
          <img src="https://cdn.magicpatterns.com/uploads/eUuEsi3RCpqr5RwgUP2D5g/dadc0422-4059-45b9-8ac9-04682b3828a6.png" alt="MegaPack Inclusión Lista — recursos, herramientas y estrategias para inclusión real" className="w-full max-w-[560px] md:max-w-2xl drop-shadow-2xl pl-[50px] pr-[50px]" data-id="element-94" />
        </div>

        <div className="flex flex-col items-center gap-3 mb-6" data-id="element-95">
          <div className="flex items-center gap-2" data-id="element-96">
            <div className="flex gap-0.5" data-id="element-97">
              {[...Array(5)].map((_, i) => <Star key={i} size={16} className="fill-accent text-accent" data-id="element-98" />)}
            </div>
            <span className="text-ink font-bold text-sm" data-id="element-99">4.9/5</span>
            <span className="text-muted text-xs" data-id="element-100">
              (+600 reseñas verificadas)
            </span>
          </div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.5,
          delay: 0.3
        }} className="inline-flex items-center gap-2 bg-accent/10 border border-accent/40 px-4 py-1.5 rounded-full shadow-[0_0_25px_rgba(184,153,104,0.35)]" data-id="element-101">
            <Flame size={14} className="text-accent fill-accent/40" data-id="element-102" />
            <span className="text-ink/85 text-xs md:text-sm font-semibold" data-id="element-103">
              47 profesionales han elegido la biblioteca hoy
            </span>
          </motion.div>
        </div>

        <motion.a href="#comprar" whileHover={{
        scale: 1.02
      }} whileTap={{
        scale: 0.98
      }} className="inline-block bg-accent hover:bg-accent/90 text-black font-bold md:text-lg py-3 px-6 md:px-10 rounded-xl shadow-lg shadow-accent/20 transition-colors text-[18px] font-[Poppins,_sans-serif]" data-id="element-104">
          🔥Acceder al megapack
        </motion.a>

        <div className="flex flex-wrap mt-6 gap-[5px] items-start justify-center" data-id="element-105">
          <div className="flex items-center gap-1.5 text-muted font-medium text-[12px]" data-id="element-106">
            <Layers size={16} className="text-accent" data-id="element-107" />
            Material organizado por edades
          </div>
          <div className="flex items-center gap-1.5 text-muted font-medium text-[12px]" data-id="element-108">
            <ShieldCheck size={16} className="text-sky" data-id="element-109" />
            Pago seguro
          </div>
          <div className="flex items-center gap-1.5 text-muted font-medium text-[12px]" data-id="element-110">
            <CreditCard size={16} className="text-accent" data-id="element-111" />
            Mercado Pago
          </div>
        </div>
      </motion.div>
    </section>;
}